var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g2, _g3, _g4, _g5, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _g6, _g7, _g8, _g9, _g0, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _g1, _g10, _path244, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroSectionBgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 2842 1132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "background_svg__b",
    width: 2842,
    height: 1132,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__a)",
    d: "M0 0h2842v1132H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__c)",
    d: "M0 0h2842v1132H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__d)",
    d: "M0 0h2842v1132H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__e)",
    d: "M0 0h2842v1132H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__f)",
    d: "M0 0h2842v1132H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__g)",
    d: "M0 0h2842v1132H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__h)",
    d: "M0 0h2842v1132H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__i)",
    d: "M0 1h489v1131H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__j)",
    d: "M2842 1132h489v1131h-489z",
    transform: "rotate(-180 2842 1132)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__k)",
    fillOpacity: 0.08,
    d: "M1662.67 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__l)",
    fillOpacity: 0.08,
    d: "M1704.82 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__m)",
    fillOpacity: 0.08,
    d: "M1515.32 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__n)",
    fillOpacity: 0.08,
    d: "M1599.61 190.619v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__o)",
    fillOpacity: 0.08,
    d: "M1641.78 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__p)",
    fillOpacity: 0.08,
    d: "M1810.39 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__q)",
    fillOpacity: 0.08,
    d: "M1451.89 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__r)",
    fillOpacity: 0.08,
    d: "M1662.67 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__s)",
    fillOpacity: 0.08,
    d: "M1746.96 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__t)",
    fillOpacity: 0.08,
    d: "M1599.61 118.822v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.301z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__u)",
    fillOpacity: 0.08,
    d: "M1768.25 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__v)",
    fillOpacity: 0.08,
    d: "M1810.39 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__w)",
    fillOpacity: 0.08,
    d: "M1578.78 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__x)",
    fillOpacity: 0.08,
    d: "M1705.25 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__y)",
    fillOpacity: 0.08,
    d: "M1578.42 82.547v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__z)",
    fillOpacity: 0.08,
    d: "M1704.87 82.547v-22.6l19.78-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__A)",
    fillOpacity: 0.06,
    d: "M1515.32 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__B)",
    fillOpacity: 0.06,
    d: "M1557.46 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__C)",
    fillOpacity: 0.06,
    d: "M1599.61 262.33v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__D)",
    fillOpacity: 0.06,
    d: "M1494.03 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__E)",
    fillOpacity: 0.06,
    d: "M1620.5 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__F)",
    fillOpacity: 0.06,
    d: "M1746.96 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__G)",
    fillOpacity: 0.06,
    d: "M1789.14 226.694v-22.601l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__H)",
    fillOpacity: 0.06,
    d: "M1683.93 190.619v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__I)",
    fillOpacity: 0.06,
    d: "M1726.07 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__J)",
    fillOpacity: 0.06,
    d: "M1768.25 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__K)",
    fillOpacity: 0.06,
    d: "M1557.83 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__L)",
    fillOpacity: 0.06,
    d: "M1599.97 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__M)",
    fillOpacity: 0.06,
    d: "M1642.15 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__N)",
    fillOpacity: 0.06,
    d: "M1515.32 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__O)",
    fillOpacity: 0.06,
    d: "M1557.46 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__P)",
    fillOpacity: 0.06,
    d: "M1641.78 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Q)",
    fillOpacity: 0.06,
    d: "M1494.48 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__R)",
    fillOpacity: 0.06,
    d: "M1536.63 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__S)",
    fillOpacity: 0.06,
    d: "M1663.1 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__T)",
    fillOpacity: 0.06,
    d: "M1662.73 82.547v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__U)",
    fillOpacity: 0.06,
    d: "M1747.03 82.547v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__V)",
    fillOpacity: 0.06,
    d: "M1789.2 82.547v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__W)",
    fillOpacity: 0.06,
    d: "M1431 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__X)",
    fillOpacity: 0.06,
    d: "M1473.14 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Y)",
    fillOpacity: 0.06,
    d: "M1641.78 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Z)",
    fillOpacity: 0.06,
    d: "M1683.93 262.33v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aa)",
    fillOpacity: 0.06,
    d: "M1726.07 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ab)",
    fillOpacity: 0.06,
    d: "M1768.25 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ac)",
    fillOpacity: 0.06,
    d: "M1810.39 262.33v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ad)",
    fillOpacity: 0.06,
    d: "M1451.89 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ae)",
    fillOpacity: 0.06,
    d: "M1536.2 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__af)",
    fillOpacity: 0.06,
    d: "M1578.35 226.694v-22.601l19.78-11.3 19.77 11.3v22.601l-19.77 11.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ag)",
    fillOpacity: 0.06,
    d: "M1431 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ah)",
    fillOpacity: 0.06,
    d: "M1473.14 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ai)",
    fillOpacity: 0.06,
    d: "M1494.03 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aj)",
    fillOpacity: 0.06,
    d: "M1536.2 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ak)",
    fillOpacity: 0.06,
    d: "M1578.35 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__al)",
    fillOpacity: 0.06,
    d: "M1620.5 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__am)",
    fillOpacity: 0.06,
    d: "M1704.82 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__an)",
    fillOpacity: 0.06,
    d: "M1789.14 154.598v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ao)",
    fillOpacity: 0.06,
    d: "M1473.52 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ap)",
    fillOpacity: 0.06,
    d: "M1515.68 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aq)",
    fillOpacity: 0.06,
    d: "M1684.29 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ar)",
    fillOpacity: 0.06,
    d: "M1726.44 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__as)",
    fillOpacity: 0.06,
    d: "M1768.61 334.494v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__at)",
    fillOpacity: 0.06,
    d: "M1431 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__au)",
    fillOpacity: 0.06,
    d: "M1473.14 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__av)",
    fillOpacity: 0.06,
    d: "M1683.93 118.822v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.301z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aw)",
    fillOpacity: 0.06,
    d: "M1726.07 118.822v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.301z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ax)",
    fillOpacity: 0.06,
    d: "M1452.32 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ay)",
    fillOpacity: 0.06,
    d: "M1620.95 298.219v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__az)",
    fillOpacity: 0.06,
    d: "M1747.39 298.219v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aA)",
    fillOpacity: 0.06,
    d: "M1789.57 298.219v-22.6l19.78-11.301 19.77 11.301v22.6l-19.77 11.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aB)",
    fillOpacity: 0.06,
    d: "M1451.95 82.547v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aC)",
    fillOpacity: 0.06,
    d: "M1494.12 82.547v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aD)",
    fillOpacity: 0.06,
    d: "M1536.27 82.547v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aE)",
    fillOpacity: 0.06,
    d: "M1620.58 82.547v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aF)",
    fillOpacity: 0.06,
    d: "M1557.46 190.619v-22.6l19.78-11.3 19.77 11.3v22.6l-19.77 11.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4D351E",
    d: "M1493.7 81.502v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aG)",
    strokeLinecap: "round",
    d: "M1493.7 81.502v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aH)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1493.7 81.502v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4D351E",
    d: "M1514.88 190.553v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aI)",
    strokeLinecap: "round",
    d: "M1514.88 190.553v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aJ)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1514.88 190.553v-22.6l19.77-11.3 19.78 11.3v22.6l-19.78 11.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4D351E",
    d: "M1557.04 189.561V166.96l19.77-11.3 19.78 11.3v22.601l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aK)",
    strokeLinecap: "round",
    d: "M1557.04 189.561V166.96l19.77-11.3 19.78 11.3v22.601l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aL)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1557.04 189.561V166.96l19.77-11.3 19.78 11.3v22.601l-19.78 11.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4D351E",
    d: "M1536.65 226.512v-22.6l19.77-11.301 19.78 11.301v22.6l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aM)",
    strokeLinecap: "round",
    d: "M1536.65 226.512v-22.6l19.77-11.301 19.78 11.301v22.6l-19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__aN)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1536.65 226.512v-22.6l19.77-11.301 19.78 11.301v22.6l-19.78 11.3z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aO)",
    d: "M699.27 230.262v-22.6l-19.776-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aP)",
    d: "M657.121 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aQ)",
    d: "M846.621 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aR)",
    d: "M762.332 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aS)",
    d: "M720.16 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aT)",
    d: "M551.551 194.188v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aU)",
    d: "M910.051 158.166v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aV)",
    d: "M699.27 158.166v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aW)",
    d: "M614.98 158.166v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aX)",
    d: "M762.332 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aY)",
    d: "M593.691 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aZ)",
    d: "M551.551 122.391v-22.6l-19.775-11.3L512 99.79v22.6l19.776 11.3z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ba)",
    d: "M783.16 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bb)",
    d: "M656.691 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bc)",
    d: "M783.52 86.115v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bd)",
    d: "M657.066 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__be)",
    fillOpacity: 0.7,
    d: "M846.621 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bf)",
    fillOpacity: 0.7,
    d: "M846.621 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bg)",
    fillOpacity: 0.7,
    d: "M804.48 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bh)",
    fillOpacity: 0.7,
    d: "M804.48 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bi)",
    fillOpacity: 0.7,
    d: "M762.332 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bj)",
    fillOpacity: 0.7,
    d: "M762.332 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bk)",
    fillOpacity: 0.7,
    d: "M867.91 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bl)",
    fillOpacity: 0.7,
    d: "M867.91 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bm)",
    fillOpacity: 0.7,
    d: "M741.441 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bn)",
    fillOpacity: 0.7,
    d: "M741.441 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bo)",
    fillOpacity: 0.7,
    d: "M614.98 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bp)",
    fillOpacity: 0.7,
    d: "M614.98 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bq)",
    fillOpacity: 0.7,
    d: "M572.801 230.262v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__br)",
    fillOpacity: 0.7,
    d: "M572.801 230.262v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bs)",
    fillOpacity: 0.7,
    d: "M678.012 194.188v-22.601l-19.776-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bt)",
    fillOpacity: 0.7,
    d: "M678.012 194.188v-22.601l-19.776-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bu)",
    fillOpacity: 0.7,
    d: "M635.871 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bv)",
    fillOpacity: 0.7,
    d: "M635.871 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bw)",
    fillOpacity: 0.7,
    d: "M593.691 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bx)",
    fillOpacity: 0.7,
    d: "M593.691 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__by)",
    fillOpacity: 0.7,
    d: "M804.113 338.063v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bz)",
    fillOpacity: 0.7,
    d: "M804.113 338.063v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bA)",
    fillOpacity: 0.7,
    d: "M761.973 338.063v-22.601l-19.776-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bB)",
    fillOpacity: 0.7,
    d: "M761.973 338.063v-22.601l-19.776-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bC)",
    fillOpacity: 0.7,
    d: "M719.793 338.063v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bD)",
    fillOpacity: 0.7,
    d: "M719.793 338.063v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bE)",
    fillOpacity: 0.7,
    d: "M846.621 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bF)",
    fillOpacity: 0.7,
    d: "M846.621 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bG)",
    fillOpacity: 0.7,
    d: "M804.48 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bH)",
    fillOpacity: 0.7,
    d: "M804.48 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bI)",
    fillOpacity: 0.7,
    d: "M720.16 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bJ)",
    fillOpacity: 0.7,
    d: "M720.16 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bK)",
    fillOpacity: 0.7,
    d: "M867.457 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bL)",
    fillOpacity: 0.7,
    d: "M867.457 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bM)",
    fillOpacity: 0.7,
    d: "M825.309 301.787v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bN)",
    fillOpacity: 0.7,
    d: "M825.309 301.787v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bO)",
    fillOpacity: 0.7,
    d: "M698.84 301.787v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bP)",
    fillOpacity: 0.7,
    d: "M698.84 301.787v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bQ)",
    fillOpacity: 0.7,
    d: "M699.207 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bR)",
    fillOpacity: 0.7,
    d: "M699.207 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bS)",
    fillOpacity: 0.7,
    d: "M614.91 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bT)",
    fillOpacity: 0.7,
    d: "M614.91 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bU)",
    fillOpacity: 0.7,
    d: "M572.746 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bV)",
    fillOpacity: 0.7,
    d: "M572.746 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bW)",
    fillOpacity: 0.3,
    d: "M930.941 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bX)",
    fillOpacity: 0.3,
    d: "M888.801 265.899v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bY)",
    fillOpacity: 0.3,
    d: "M720.16 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bZ)",
    fillOpacity: 0.3,
    d: "M678.012 265.899v-22.601l-19.776-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ca)",
    fillOpacity: 0.3,
    d: "M635.871 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cb)",
    fillOpacity: 0.3,
    d: "M593.691 265.899v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cc)",
    fillOpacity: 0.3,
    d: "M551.551 265.899v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cd)",
    fillOpacity: 0.3,
    d: "M910.051 230.262v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ce)",
    fillOpacity: 0.3,
    d: "M825.738 230.262v-22.6l-19.775-11.301-19.775 11.301v22.6l19.775 11.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cf)",
    fillOpacity: 0.3,
    d: "M783.59 230.262v-22.6l-19.775-11.301-19.776 11.301v22.6l19.776 11.3z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cg)",
    fillOpacity: 0.3,
    d: "M930.941 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ch)",
    fillOpacity: 0.3,
    d: "M888.801 194.188v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ci)",
    fillOpacity: 0.3,
    d: "M867.91 158.166v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cj)",
    fillOpacity: 0.3,
    d: "M825.738 158.166v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ck)",
    fillOpacity: 0.3,
    d: "M783.59 158.166v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cl)",
    fillOpacity: 0.3,
    d: "M741.441 158.166v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cm)",
    fillOpacity: 0.3,
    d: "M657.121 158.166v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cn)",
    fillOpacity: 0.3,
    d: "M572.801 158.166v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__co)",
    fillOpacity: 0.3,
    d: "M888.426 338.063v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cp)",
    fillOpacity: 0.3,
    d: "M846.262 338.063v-22.601l-19.776-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cq)",
    fillOpacity: 0.3,
    d: "M677.652 338.063v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cr)",
    fillOpacity: 0.3,
    d: "M635.504 338.063v-22.601l-19.775-11.3-19.776 11.3v22.601l19.776 11.3z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cs)",
    fillOpacity: 0.3,
    d: "M593.332 338.063v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ct)",
    fillOpacity: 0.3,
    d: "M930.941 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cu)",
    fillOpacity: 0.3,
    d: "M888.801 122.391v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cv)",
    fillOpacity: 0.3,
    d: "M678.012 122.391v-22.6l-19.776-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cw)",
    fillOpacity: 0.3,
    d: "M635.871 122.391v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cx)",
    fillOpacity: 0.3,
    d: "M909.621 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cy)",
    fillOpacity: 0.3,
    d: "M740.988 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cz)",
    fillOpacity: 0.3,
    d: "M614.551 301.787v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cA)",
    fillOpacity: 0.3,
    d: "M572.371 301.787v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cB)",
    fillOpacity: 0.3,
    d: "M909.988 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cC)",
    fillOpacity: 0.3,
    d: "M867.824 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cD)",
    fillOpacity: 0.3,
    d: "M825.676 86.115v-22.6l-19.775-11.3-19.776 11.3v22.6l19.776 11.3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cE)",
    fillOpacity: 0.3,
    d: "M741.363 86.115v-22.6l-19.775-11.3-19.775 11.3v22.6l19.775 11.3z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cF)",
    fillOpacity: 0.3,
    d: "M804.48 194.188v-22.601l-19.775-11.3-19.775 11.3v22.601l19.775 11.3z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12111D",
    d: "M659.5 230.063v-22.601l19.775-11.3 19.775 11.3v22.601l-19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cG)",
    strokeLinecap: "round",
    strokeOpacity: 0.33,
    d: "M679.275 196.738 660 207.753v22.02l19.275 11.014 19.275-11.014v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cH)",
    strokeLinecap: "round",
    strokeOpacity: 0.24,
    d: "M679.275 196.738 660 207.753v22.02l19.275 11.014 19.275-11.014v-22.02z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12111D",
    d: "M786.348 86.658v-22.6l19.775-11.3 19.775 11.3v22.6l-19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cI)",
    strokeLinecap: "round",
    strokeOpacity: 0.33,
    d: "m806.123 53.334-19.275 11.014v22.02l19.275 11.015 19.275-11.015v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cJ)",
    strokeLinecap: "round",
    strokeOpacity: 0.24,
    d: "m806.123 53.334-19.275 11.014v22.02l19.275 11.015 19.275-11.015v-22.02z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12111D",
    d: "M638.254 194.305v-22.6l19.775-11.301 19.775 11.301v22.6l-19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cK)",
    strokeLinecap: "round",
    strokeOpacity: 0.33,
    d: "m658.029 160.98-19.275 11.015v22.02l19.275 11.014 19.275-11.014v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cL)",
    strokeLinecap: "round",
    strokeOpacity: 0.24,
    d: "m658.029 160.98-19.275 11.015v22.02l19.275 11.014 19.275-11.014v-22.02z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12111D",
    d: "M765.102 50.9V28.3L784.877 17l19.775 11.3v22.6l-19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cM)",
    strokeLinecap: "round",
    strokeOpacity: 0.33,
    d: "M784.877 17.576 765.602 28.59v22.02l19.275 11.015 19.275-11.015V28.59z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cN)",
    strokeLinecap: "round",
    strokeOpacity: 0.24,
    d: "M784.877 17.576 765.602 28.59v22.02l19.275 11.015 19.275-11.015V28.59z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12111D",
    d: "M744.188 86.67v-22.6l19.775-11.3 19.775 11.3v22.6l-19.775 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cO)",
    strokeLinecap: "round",
    strokeOpacity: 0.33,
    d: "M763.963 53.346 744.688 64.36v22.02l19.275 11.014 19.275-11.014V64.36z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cP)",
    strokeLinecap: "round",
    strokeOpacity: 0.24,
    d: "M763.963 53.346 744.688 64.36v22.02l19.275 11.014 19.275-11.014V64.36z"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cQ)",
    fillOpacity: 0.12,
    d: "M2105.27 1003.65v-22.602l-19.78-11.3-19.77 11.3v22.602l19.77 11.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cR)",
    fillOpacity: 0.12,
    d: "M2063.12 1003.65v-22.602l-19.77-11.3-19.78 11.3v22.602l19.78 11.3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cS)",
    fillOpacity: 0.12,
    d: "M2252.62 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cT)",
    fillOpacity: 0.12,
    d: "M2168.33 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cU)",
    fillOpacity: 0.12,
    d: "M2126.16 967.574v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cV)",
    fillOpacity: 0.12,
    d: "M1957.55 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cW)",
    fillOpacity: 0.12,
    d: "M2316.05 931.553v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cX)",
    fillOpacity: 0.12,
    d: "M2105.27 931.553v-22.6l-19.78-11.301-19.77 11.301v22.6l19.77 11.3z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cY)",
    fillOpacity: 0.12,
    d: "M2020.98 931.553v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cZ)",
    fillOpacity: 0.12,
    d: "M2168.33 895.777v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__da)",
    fillOpacity: 0.12,
    d: "M1999.69 895.777v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__db)",
    fillOpacity: 0.12,
    d: "M1957.55 895.777v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dc)",
    fillOpacity: 0.12,
    d: "M2189.16 1075.17v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dd)",
    fillOpacity: 0.12,
    d: "M2062.69 1075.17v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__de)",
    fillOpacity: 0.12,
    d: "M2189.52 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__df)",
    fillOpacity: 0.12,
    d: "M2063.07 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dg)",
    fillOpacity: 0.04,
    d: "M2252.62 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dh)",
    fillOpacity: 0.04,
    d: "M2210.48 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__di)",
    fillOpacity: 0.04,
    d: "M2168.33 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dj)",
    fillOpacity: 0.04,
    d: "M2273.91 1003.65v-22.602l-19.78-11.3-19.77 11.3v22.602l19.77 11.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dk)",
    fillOpacity: 0.04,
    d: "M2147.44 1003.65v-22.602l-19.77-11.3-19.78 11.3v22.602l19.78 11.3z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dl)",
    fillOpacity: 0.04,
    d: "M2020.98 1003.65v-22.602l-19.77-11.3-19.78 11.3v22.602l19.78 11.3z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dm)",
    fillOpacity: 0.04,
    d: "M1978.8 1003.65v-22.602l-19.77-11.3-19.78 11.3v22.602l19.78 11.3z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dn)",
    fillOpacity: 0.04,
    d: "M2084.01 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__do)",
    fillOpacity: 0.04,
    d: "M2041.87 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dp)",
    fillOpacity: 0.04,
    d: "M1999.69 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dq)",
    fillOpacity: 0.04,
    d: "M2210.11 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dr)",
    fillOpacity: 0.04,
    d: "M2167.97 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ds)",
    fillOpacity: 0.04,
    d: "M2125.79 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dt)",
    fillOpacity: 0.04,
    d: "M2252.62 895.778v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__du)",
    fillOpacity: 0.04,
    d: "M2210.48 895.778v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dv)",
    fillOpacity: 0.04,
    d: "M2126.16 895.777v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.301z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dw)",
    fillOpacity: 0.04,
    d: "M2273.46 1075.17v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dx)",
    fillOpacity: 0.04,
    d: "M2231.31 1075.17v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dy)",
    fillOpacity: 0.04,
    d: "M2104.84 1075.17v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dz)",
    fillOpacity: 0.04,
    d: "M2105.21 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dA)",
    fillOpacity: 0.04,
    d: "M2020.91 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dB)",
    fillOpacity: 0.04,
    d: "M1978.75 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dC)",
    fillOpacity: 0.06,
    d: "M2336.94 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dD)",
    fillOpacity: 0.06,
    d: "M2294.8 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dE)",
    fillOpacity: 0.06,
    d: "M2126.16 1039.29v-22.6l-19.78-11.31-19.77 11.31v22.6l19.77 11.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dF)",
    fillOpacity: 0.06,
    d: "M2084.01 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dG)",
    fillOpacity: 0.06,
    d: "M2041.87 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dH)",
    fillOpacity: 0.06,
    d: "M1999.69 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dI)",
    fillOpacity: 0.06,
    d: "M1957.55 1039.29v-22.6l-19.77-11.31-19.78 11.31v22.6l19.78 11.3z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dJ)",
    fillOpacity: 0.06,
    d: "M2316.05 1003.65v-22.602l-19.77-11.3-19.78 11.3v22.602l19.78 11.3z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dK)",
    fillOpacity: 0.06,
    d: "M2231.74 1003.65v-22.602l-19.78-11.3-19.77 11.3v22.602l19.77 11.3z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dL)",
    fillOpacity: 0.06,
    d: "M2189.59 1003.65v-22.602l-19.78-11.3-19.77 11.3v22.602l19.77 11.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dM)",
    fillOpacity: 0.06,
    d: "M2336.94 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dN)",
    fillOpacity: 0.06,
    d: "M2294.8 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dO)",
    fillOpacity: 0.06,
    d: "M2273.91 931.553v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dP)",
    fillOpacity: 0.06,
    d: "M2231.74 931.553v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dQ)",
    fillOpacity: 0.06,
    d: "M2189.59 931.553v-22.6l-19.78-11.301-19.77 11.301v22.6l19.77 11.3z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dR)",
    fillOpacity: 0.06,
    d: "M2147.44 931.553v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dS)",
    fillOpacity: 0.06,
    d: "M2063.12 931.553v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dT)",
    fillOpacity: 0.06,
    d: "M1978.8 931.553v-22.6l-19.77-11.301-19.78 11.301v22.6l19.78 11.3z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dU)",
    fillOpacity: 0.06,
    d: "M2294.43 1111.45v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dV)",
    fillOpacity: 0.06,
    d: "M2252.26 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dW)",
    fillOpacity: 0.06,
    d: "M2083.65 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dX)",
    fillOpacity: 0.06,
    d: "M2041.5 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dY)",
    fillOpacity: 0.06,
    d: "M1999.33 1111.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dZ)",
    fillOpacity: 0.06,
    d: "M2336.94 895.778v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ea)",
    fillOpacity: 0.06,
    d: "M2294.8 895.778v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__eb)",
    fillOpacity: 0.06,
    d: "M2084.01 895.777v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ec)",
    fillOpacity: 0.06,
    d: "M2041.87 895.777v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.301z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ed)",
    fillOpacity: 0.06,
    d: "M2315.62 1075.17v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ee)",
    fillOpacity: 0.06,
    d: "M2146.99 1075.17v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ef)",
    fillOpacity: 0.06,
    d: "M2020.55 1075.17v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__eg)",
    fillOpacity: 0.06,
    d: "M1978.37 1075.17v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__eh)",
    fillOpacity: 0.06,
    d: "M2315.99 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ei)",
    fillOpacity: 0.06,
    d: "M2273.82 859.502v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ej)",
    fillOpacity: 0.06,
    d: "M2231.68 859.502v-22.6l-19.78-11.3-19.77 11.3v22.6l19.77 11.3z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ek)",
    fillOpacity: 0.06,
    d: "M2147.36 859.502v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__el)",
    fillOpacity: 0.06,
    d: "M2210.48 967.574v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1A19",
    d: "M2188.94 1002.45v-22.601l-19.77-11.3-19.78 11.3v22.601l19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__em)",
    strokeLinecap: "round",
    strokeOpacity: 0.48,
    d: "m2169.17 969.125 19.27 11.014v22.021l-19.27 11.01-19.28-11.01v-22.021z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__en)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m2169.17 969.125 19.27 11.014v22.021l-19.27 11.01-19.28-11.01v-22.021z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1615",
    d: "M2167.94 1038.45v-22.6l-19.77-11.3-19.78 11.3v22.6l19.78 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__eo)",
    strokeLinecap: "round",
    strokeOpacity: 0.78,
    d: "m2148.17 1005.12 19.27 11.02v22.02l-19.27 11.01-19.28-11.01v-22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__ep)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m2148.17 1005.12 19.27 11.02v22.02l-19.27 11.01-19.28-11.01v-22.02z"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__eq)",
    d: "M2127.5 1038.48v-23.49l20.99-11.86m0 0v-23.501l17.81-10.404m-17.81 33.905 19 11",
    opacity: 0.33
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-345.50053 749.99937 -955.98912 -440.39336 1644.5 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#130D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130D0D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(116.496 655.5 405.667)scale(555.887 311.691)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1622",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-484.99599 595.003 -278.00178 -226.60348 1699 -62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201612",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-241.0013 289.99898 -245.94874 -204.3937 1970 470)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15161F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(130.428 706.881 751.046)scale(341.558 289.676)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1B1E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.9996 -59.00024 51.94505 -34.33607 1687 194.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F3A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.99995 -59.5 67.0223 36.04555 1531 176.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17C31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ah",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-54.99945 63.00043 -89.80281 -78.39797 1508.5 168.294)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F49",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(146.198 767.825 264.484)scale(71.0018 79.522)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-21.987 951.755 -3736.16)scale(38.1158 42.6897)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(88.011 698.43 870.83)scale(72.0434 80.6886)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(35.0273 -28.21938 31.60574 39.2306 1489.5 207.602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.81644 -52.28843 58.56303 38.9944 1554.68 190.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29405C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD8AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-41.358 1041.76 -1927.622)scale(44.2093 49.5145)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(127.875 743.434 486.655)scale(62.7096 70.2348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-45.959 1047.41 -1667.567)scale(40.7048 45.5894)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ba",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-98.50054 43.49937 -36.31526 -82.23274 693.051 211.363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__br",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__by",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(107.896 344.291 330.451)scale(100.881 113.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-127.405 421.316 -63.961)scale(107.005 120.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ca",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ce",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ch",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ci",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ck",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__co",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ct",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-115.50026 -38.5002 23.72578 -71.17713 738.551 235.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(136.16 320.535 247.27)scale(87.3456 97.8271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-31.661 761.37 -1021.521)scale(70.4911 78.9501)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-178.409 425.458 32.58)scale(72.0278 80.6711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(60.99998 18.49996 -20.71997 68.32005 774.348 65.959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(139.138 319.19 214.617)scale(83.3022 93.2984)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-29.129 707.917 -1099.006)scale(74.9833 83.9813)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-178.409 414.587 14.848)scale(72.0278 80.6711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(60.99998 18.49996 -20.71997 68.32005 753.102 30.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-178.409 404.378 32.878)scale(72.0278 80.6711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(60.99998 18.49996 -20.71997 68.32005 732.188 65.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__da",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__db",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__de",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__df",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-51.129 2085.69 -1721.36)scale(274.868 227.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__di",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__do",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ds",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__du",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.50005 -92.49995 104.19416 -15.20678 2120.44 991.749)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ea",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__eb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ec",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ed",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ee",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ef",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__eg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__eh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ei",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ej",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ek",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__el",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-60.9 1930.68 -1294.088)scale(60.6568 63.3839)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#564F4D",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564F4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__em",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-103.211 1499.173 -349.397)scale(40.0301 44.8337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1D9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4529",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__en",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(18.875 -1861.144 6856.351)scale(61.8243 69.2433)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__eo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-137.978 1300.333 108.892)scale(61.2474 68.5971)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1D9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4529",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ep",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(35.154 -521.18 3846.963)scale(43.4195 48.6298)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__a",
    x1: 1421,
    x2: 1421,
    y1: 172.147,
    y2: 1132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#040406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#18181A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__c",
    x1: 1421,
    x2: 1421,
    y1: 172.147,
    y2: 1132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#040406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#18181A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__i",
    x1: 31.048,
    x2: 458.805,
    y1: 596.5,
    y2: 613.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#040406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#040406",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__j",
    x1: 2873.05,
    x2: 3300.81,
    y1: 1727.5,
    y2: 1744.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#040406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#040406",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__eq",
    x1: 2152.5,
    x2: 2142.45,
    y1: 1020.6,
    y2: 974.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionBgImage);
export default __webpack_public_path__ + "static/media/hero-section-bg-image.6c8c2208b2198db37a82d185bca3646d.svg";
export { ForwardRef as ReactComponent };